<template>
    <div>
        <el-card style='margin-top: 1rem;overflow: unset;' class='box-card'>
            <div slot='header' class='clearfix'>
                <span>{{ trackReportSetting.name }}</span>
            </div>
            <track-event-chart :event-id='queryParams.eventId'
                               :track-report-setting-id='queryParams.reportId'
                               :project-app-id='queryParams.projectAppId' />
        </el-card>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { projectInfoApi } from '@api/ProjectInfo';
import bus from '@/components/common/bus';
import { message } from '@/utils/message';
import { trackReportSettingApi } from '@api/Track/trackReportSetting';
import { trackEventApi } from '@api/Track/trackEvent';
import TrackEventChart from '@view/track/analyse/component/TrackEventChart.vue';

export default defineComponent({
    name: 'TrackSummary',
    components: { TrackEventChart },
    data() {
        return {
            queryParams: {
                projectAppId: undefined,
                eventId: undefined,
                startTime: undefined,
                endTime: undefined,
                reportId: undefined
            },
            projectInfo: {},
            trackEventInfo: {},
            charOption: {
                showOptions: {}
            },
            trackReportSettingList: [],
            trackReportSetting: {
                id: undefined
            }
        };
    },
    created() {
        this.setInitValue()
        if (this.queryParams.projectAppId) {
            bus.$emit('queriedTrackProjectAppId', this.queryParams.projectAppId)
        }
        if (this.queryParams.eventId) {
            bus.$emit('queriedTrackEventId', this.queryParams.eventId)
        }
        
        bus.$on('selectedTrackProjectAppId', this.handleSelectedTrackProjectAppIdEvent)
        bus.$on('trackEventIdChange', this.handleTrackEventIdChange)
    },
    beforeDestroy() {
        bus.$off('selectedTrackProjectAppId', this.handleSelectedTrackProjectAppIdEvent)
        bus.$off('trackEventIdChange', this.handleTrackEventIdChange)
    },
    computed: {
    
    },
    methods: {
        reset() {
            this.queryParams = {
                projectAppId: this.queryParams.projectAppId,
                eventId: undefined,
                startTime: undefined,
                endTime: undefined
            }
            this.getList()
        },
        getList() {
            if (!this.queryParams.projectAppId || this.queryParams.projectAppId.indexOf('undefined') === 0) {
                this.$router.push(`/trackAnalyse`)
                return
            }
            
            if (!this.queryParams.reportId || this.queryParams.reportId.indexOf('undefined') === 0) {
                this.$router.push(`/trackAnalyse/eventSummary/${this.queryParams.projectAppId}`)
                return
            }
            
            projectInfoApi.query({ appId: this.queryParams.projectAppId }).then(result => {
                if (result.code === 200) {
                    this.projectInfo = result.data.result[0];
                }
            })
            
            trackEventApi.queryTrackEvent({id: this.queryParams.eventId}).then(result => {
                if (result.code === 200) {
                    if (result.data.result) {
                        this.trackEventInfo = result.data.result[0]
                    }else {
                        message.error('埋点事件不存在!')
                    }
                }
            })
            
            trackReportSettingApi.queryOne({id: this.queryParams.reportId}).then(result => {
                if (result.code === 200) {
                    if (result.data) {
                        this.trackReportSetting = result.data
                    }else {
                        message.success('该埋点事件无任何报表设置!')
                    }
                }
            })
            
        },
        handleTrackEventIdChange(data) {
            this.queryParams.projectAppId = data.projectAppId
            this.queryParams.eventId = data.eventId
            this.getList()
        },
        handleSelectedTrackProjectAppIdEvent(t) {
            this.queryParams.projectAppId = t
            this.$router.push(`/trackAnalyse/eventAnalyse/${t}`)
            this.setInitValue()
        },
        setInitValue() {
            this.queryParams.projectAppId = undefined
            this.queryParams.eventId = undefined
            this.queryParams.reportId = undefined
            if (this.$route.params.eventId && this.$route.params.eventId.indexOf('undefined') === -1) {
                this.queryParams.eventId = this.$route.params.eventId
            }
            if (this.$route.params.projectAppId && this.$route.params.projectAppId.indexOf('undefined') === -1) {
                this.queryParams.projectAppId = this.$route.params.projectAppId
            }
            if (this.$route.params.reportId && this.$route.params.reportId.indexOf('undefined') === -1) {
                this.queryParams.reportId = this.$route.params.reportId
            }
            if (!this.queryParams.projectAppId) {
                message.error('请选择项目!')
                return
            }
            this.getList()
        },
        handleTimeUnitChange() {
            this.getList()
        }
    }
});
</script>

<style scoped lang='css'>

</style>
